import ScoreEntry from "../score/ScoreEntry";
import PlaySession from "./PlaySession";

/**
* ScenarioPlaySession.js
* 
* Created on Oct 9, 2013, 3:26:16 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class ScenarioPlaySession extends PlaySession {
    constructor(scenarioID) {
        super();

        this._scenarioID = scenarioID;
        this._scores = [];
        this._keyMoments = [];
    }

    addScore(scoreValue, scoreCategory, causeID) {
        var scoreEntry = new ScoreEntry(this.getScenarioID(), causeID, scoreCategory, scoreValue);
        this.addScoreEntry(scoreEntry);
    };

    addScoreEntry(scoreEntry) {
        this._scores.push(scoreEntry);
    };

    addKeyMomentEntry(entry) {
        this._keyMoments.push(entry);
    };

    getScoreEntries(category) {
        var entries = [];
        for (var i = 0; i < this._scores.length; i++) {
            var entry = this._scores[i];
            if ((entry.scenarioID === this._scenarioID) && (ranj.isNull(category) || entry.scoreCategory === category)) {
                entries.push(entry);
            }
        }
        return entries;
    };

    getKeyMoments() {
        return this._keyMoments;
    };

    setKeyMoments(value) {
        this._keyMoments = value;
    };

    getScores() {
        return this._scores;
    };

    setScores(value) {
        this._scores = value;
    };

    getScenarioID() {
        return this._scenarioID;
    };

    setScenarioID(value) {
        this._scenarioID = value;
    };
}